﻿
import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailAktionKostenverteilung extends GuiDetailGeneric {
    constructor() {
        super("GuiDetailAktionKostenverteilung");
    }
}
